import React from "react";
import { NavLink } from "react-router-dom";

const GameCard = function (props)
{
    return (
          <NavLink className="card" to={props.link}>  
        <div >
                <h4>{props.title}</h4>
                <img className="gameCard_PreviewPic" src= {props.cardPic} alt ='Game Pic' />   
                <p style={{fontSize:'.59em'}}>{props.info}</p>   
        </div>
          </NavLink>        
    );
}
export default GameCard;